<div class="workspace vh-100 bg-linear-radial">
  <top-bar 
    class="accent" 
    [ngClass]="getAccent()"
    [isBackButtonShown]="true"
    backButtonRouterLink="../"
    backButtonText="{{ 'NAVIGATION.EBOOKS' | translate }}"
    >
    <div nav-title class="col text-center">
        <h4 [translate]="'EBOOKS.TITLE'"></h4>
    </div>
    <div content class="mb-sm-4">
      <button
        aria-controls="offcanvasEBookOptions"
        class="d-md-none option-button border-0 bg-transparent px-0"
        data-bs-target="#offcanvasEBookOptions"
        data-bs-toggle="offcanvas"
        type="button"
      >
        <app-icon name="dots-options"></app-icon>
      </button>
    </div>
    <footer>
      <div class="d-none d-md-block">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a routerLink="../../">
                {{ "EBOOKS.TITLE" | translate }}
              </a>
            </li>
            <li class="breadcrumb-item">
              <a routerLink="../../">
                {{ "EBOOKS.FILTER_LANGS.ALL" | translate }}
              </a>
            </li>
            <li class="breadcrumb-item">
              <a (click)="goToEbooksListWithFilter(getLanguageFilter())">
                {{ getEbookLanguageTranslation() | translate }}
              </a>
            </li>
            <li class="breadcrumb-item" aria-current="page" routerLink="../">
              {{ getEbookName() }}
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ "EBOOKS.READER" | translate }}
            </li>
          </ol>
        </nav>
      </div>
    </footer>
  </top-bar>
  <div class="container overflow-hidden h-100 mt-3 mt-md-4" *ngIf="!isEbookLoaded || product?.path; else noEBook">
    <p class="xsmall text-muted lh-sm mb-3 mb-md-1">{{ "EBOOKS.BETA_INFO" | translate }}</p>
    <div class="reader">
      <!-- ver-1 reader mounts early (ver unknown or 1) so its route.queryParams page navigation works;
           it only receives the ebook path once ver === 1, so a ver-2 book never triggers ver-1 logic. -->
      <app-web-browser *ngIf="ver !== 2" [ebookPath]="ver === 1 ? product?.path : undefined"></app-web-browser>
      <app-web-browser-v2 *ngIf="ver === 2" [ebookPath]="product?.path" [metadata]="metadataV2"></app-web-browser-v2>
    </div>
    </div>
  <ng-template #noEBook>
    <div class="container">
      <p class="xsmall text-muted lh-sm mb-2">{{ "EBOOKS.BETA_INFO" | translate }}</p>
      <span>{{ "EBOOKS.NO_EBOOK_ERROR" | translate }}</span>
    </div>
  </ng-template>
</div>

<div
  aria-labelledby="offcanvasEBookOptionsLabel"
  class="offcanvas offcanvas-menu offcanvas-end offcanvas-ebook-options"
  id="offcanvasEBookOptions"
  tabindex="-1"
>
  <div class="offcanvas-body p-0 pt-4 pt-sm-0 d-flex">
    <div class="w-100">
      <div class="d-flex justify-content-end">
        <button
        type="button"
        class="btn btn-primary rounded-circle btn-circle text-reset p-0"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      >
        <app-icon name="close" class="icon-white"></app-icon>
      </button>
      </div>
      <div class="mt-3 d-flex flex-column">
        <span class="fs-6">{{ "EBOOKS.TEXT_SIZE" | translate }}</span>
        <input type="range" min="0" max="6" step="1"
               id="slider" list="levels"
               [value]="getTextSizeLevel()"
               (input)="setTextSize($event.target['value'])"/>

        <datalist id="levels">
          <option value="0"></option>
          <option value="1"></option>
          <option value="2"></option>
          <option value="3"></option>
          <option value="4"></option>
          <option value="5"></option>
          <option value="6"></option>
        </datalist>
      </div>
    </div>
  </div>
</div>
